(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDirectory = (directory) => {
      if (directory.dataset.shopDirectoryReady === 'true') return;

      const tools = directory.querySelector('[data-directory-tools]');
      const search = directory.querySelector('[data-directory-search]');
      const clear = directory.querySelector('[data-directory-clear]');
      const buttons = Array.from(directory.querySelectorAll('[data-directory-letter]'));
      const groups = Array.from(directory.querySelectorAll('[data-directory-group]'));
      const status = directory.querySelector('[role="status"]');
      const noResults = directory.querySelector('[data-directory-no-results]');
      const backLinks = Array.from(directory.querySelectorAll('.shop-directory__back'));
      const statusTemplate = directory.dataset.statusTemplate;
      let activeLetter = 'all';

      if (!tools || !search || !clear || !status || !noResults) return;
      directory.dataset.shopDirectoryReady = 'true';
      tools.hidden = false;

      const normalizeSearchText = (value) => value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase();

      const update = () => {
        const query = normalizeSearchText(search.value.trim());
        let visibleCount = 0;

        groups.forEach((group) => {
          const letterMatches = activeLetter === 'all' || group.dataset.directoryGroup === activeLetter;
          let groupCount = 0;

          group.querySelectorAll('[data-directory-item]').forEach((item) => {
            const name = normalizeSearchText(item.dataset.directoryName || '');
            const isVisible = letterMatches && (!query || name.includes(query));
            item.hidden = !isVisible;
            if (isVisible) groupCount += 1;
          });

          group.hidden = groupCount === 0;
          visibleCount += groupCount;
        });

        buttons.forEach((button) => {
          const isActive = button.dataset.directoryLetter === activeLetter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        clear.hidden = query.length === 0 && activeLetter === 'all';
        noResults.hidden = visibleCount !== 0;
        status.textContent = statusTemplate.replace('__VISIBLE__', String(visibleCount));
      };

      search.addEventListener('input', update);

      clear.addEventListener('click', () => {
        search.value = '';
        activeLetter = 'all';
        update();
        search.focus();
      });

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activeLetter = button.dataset.directoryLetter;
          update();
        });
      });

      backLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = directory.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.focus({ preventScroll: true });
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          window.history.replaceState(null, '', link.getAttribute('href'));
        });
      });

      update();
    };

    document.querySelectorAll('[data-shop-directory]').forEach(initializeDirectory);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches('[data-shop-directory]')) initializeDirectory(event.target);
      event.target.querySelectorAll('[data-shop-directory]').forEach(initializeDirectory);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-directory"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeDirectory = (directory) => {
      if (directory.dataset.shopDirectoryReady === 'true') return;

      const tools = directory.querySelector('[data-directory-tools]');
      const search = directory.querySelector('[data-directory-search]');
      const clear = directory.querySelector('[data-directory-clear]');
      const buttons = Array.from(directory.querySelectorAll('[data-directory-letter]'));
      const groups = Array.from(directory.querySelectorAll('[data-directory-group]'));
      const status = directory.querySelector('[role="status"]');
      const noResults = directory.querySelector('[data-directory-no-results]');
      const backLinks = Array.from(directory.querySelectorAll('.shop-directory__back'));
      const statusTemplate = directory.dataset.statusTemplate;
      let activeLetter = 'all';

      if (!tools || !search || !clear || !status || !noResults) return;
      directory.dataset.shopDirectoryReady = 'true';
      tools.hidden = false;

      const normalizeSearchText = (value) => value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLocaleLowerCase();

      groups.forEach((group) => {
        const list = group.querySelector('.category-directory__list');
        if (!list) return;
        Array.from(list.querySelectorAll('[data-directory-item]'))
          .sort((a, b) => (a.dataset.directoryName || '').localeCompare(b.dataset.directoryName || ''))
          .forEach((item) => list.appendChild(item));
      });

      const update = () => {
        const query = normalizeSearchText(search.value.trim());
        let visibleCount = 0;

        groups.forEach((group) => {
          const letterMatches = activeLetter === 'all' || group.dataset.directoryGroup === activeLetter;
          let groupCount = 0;

          group.querySelectorAll('[data-directory-item]').forEach((item) => {
            const name = normalizeSearchText(item.dataset.directoryName || '');
            const isVisible = letterMatches && (!query || name.includes(query));
            item.hidden = !isVisible;
            if (isVisible) groupCount += 1;
          });

          group.hidden = groupCount === 0;
          visibleCount += groupCount;
        });

        buttons.forEach((button) => {
          const isActive = button.dataset.directoryLetter === activeLetter;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
        });

        clear.hidden = query.length === 0 && activeLetter === 'all';
        noResults.hidden = visibleCount !== 0;
        status.textContent = statusTemplate.replace('__VISIBLE__', String(visibleCount));
      };

      search.addEventListener('input', update);

      clear.addEventListener('click', () => {
        search.value = '';
        activeLetter = 'all';
        update();
        search.focus();
      });

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activeLetter = button.dataset.directoryLetter;
          update();
        });
      });

      backLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          const target = directory.querySelector(link.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.focus({ preventScroll: true });
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
          window.history.replaceState(null, '', link.getAttribute('href'));
        });
      });

      update();
    };

    document.querySelectorAll('[data-shop-directory]').forEach(initializeDirectory);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.matches('[data-shop-directory]')) initializeDirectory(event.target);
      event.target.querySelectorAll('[data-shop-directory]').forEach(initializeDirectory);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
(function () {
  function getResult(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var box = document.createElement('div');
        box.innerHTML = html;
        var res = box.querySelector('.be-recs__result');
        if (!res || !(parseInt(res.getAttribute('data-be-recs-count'), 10) > 0)) return null;
        return res.innerHTML;
      })
      .catch(function () { return null; });
  }

  function mount(section, html) {
    section.innerHTML = html;
    try { theme.ProductBlockManager.loadImages(section); } catch (e) {}
    try { theme.initAnimateOnScroll(); } catch (e) {}
  }

  function load(section) {
    if (section.dataset.beRecsLoaded) return;
    section.dataset.beRecsLoaded = '1';
    var base = section.dataset.url;
    var tpl = section.querySelector('template[data-be-recs-fallback]');
    var fallback = tpl ? tpl.innerHTML : null;
    var first = section.dataset.complementary === 'true'
      ? getResult(base + '&intent=complementary')
      : Promise.resolve(null);
    first
      .then(function (html) { return html || getResult(base + '&intent=related'); })
      .then(function (html) {
        html = html || fallback;
        if (html) mount(section, html);
      });
  }

  function init() {
    var sections = document.querySelectorAll('.product-recommendations.be-recs');
    Array.prototype.forEach.call(sections, function (section) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { io.disconnect(); load(section); }
          });
        }, { rootMargin: '800px 0px' });
        io.observe(section);
      } else {
        load(section);
      }
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    var s = document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations');
    if (s) { delete s.dataset.beRecsLoaded; load(s); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
